export async function enterFullscreen(targetId?: string) {
  const element = targetId ? document.getElementById(targetId) : document.documentElement
  if (!element || document.fullscreenElement || typeof element.requestFullscreen !== 'function')
    return
  await element.requestFullscreen()
}

export async function exitFullscreen() {
  if (!document.fullscreenElement) return
  await document.exitFullscreen()
}

export async function toggleFullscreen(targetId?: string) {
  try {
    if (document.fullscreenElement) {
      await exitFullscreen()
    } else {
      await enterFullscreen(targetId)
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[fullscreen] Failed to toggle fullscreen:', error)
  }
}
